/* eslint-disable no-underscore-dangle */
import tippy, { Instance, Options } from 'tippy.js';

export interface TippyHTMLElement extends HTMLElement {
  _tippy?: Instance;
}

export default class Tooltip {
  static TOOLTIP_CLASS = 'js-tooltip';

  constructor(private element: TippyHTMLElement, content?: string, options?: Options) {
    tippy(element, {
      animation: 'scale',
      theme: 'eparts',
      content,
      ...options,
    }) as Instance;
  }

  destroy(): void {
    this.element._tippy?.destroy();
  }

  setContent(content: string): void {
    this.element._tippy?.setContent(content);
  }

  static initAll(): void {
    const elements: NodeListOf<Element> = document.querySelectorAll(`.${this.TOOLTIP_CLASS}`);

    elements.forEach((item) => {
      tippy(item, {
        animation: 'scale',
        theme: item.getAttribute('data-tippy-theme') ?? 'eparts',
        trigger: item.getAttribute('data-tippy-trigger') ?? 'click',
      });
    });
  }
}
